import script from "./BlockDropsDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockDropsDescription.vue?vue&type=script&setup=true&lang=js"

import "./BlockDropsDescription.vue?vue&type=style&index=0&id=015c2aac&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-015c2aac"]])

export default __exports__